/**
 * The "Find LinkedIn URN" bookmarklet, generated from a real function via
 * `.toString()` so there is NO hand-escaped string to mangle. (A literal like
 * "\d+" silently corrupts to "d+" in a JS string — exactly the silent-failure
 * risk that makes copy-pasting a raw bookmarklet dangerous.)
 *
 * The function MUST be fully self-contained — no imports, no closure over
 * module scope — because only its own body is serialised into the bookmarklet.
 * Delivered as a DRAGGABLE link (see LinkedInUrnHelper); dragging preserves the
 * href byte-for-byte, so the operator never copy-pastes this blob.
 *
 * 2026-09-10: made resilient to the real failure operators hit — clicking the
 * bookmark before LinkedIn's data blobs have hydrated. It now POLLS for a few
 * seconds, and only claims "signed out" when there's positive evidence of an
 * auth page (never as a guess). The old version false-reported "not signed in"
 * to a signed-in operator whose page simply hadn't finished loading.
 */

/* eslint-disable */
function findLinkedInUrn() {
  var slug = decodeURIComponent((location.pathname.split('/company/')[1] || '').split('/')[0] || '');
  if (!slug) { alert('Open a company page first — the web address should contain /company/.'); return; }

  function scan() {
    var codes = document.querySelectorAll('code');
    for (var i = 0; i < codes.length; i++) {
      var t = codes[i].textContent || '';
      if (t.indexOf('"universalName":"' + slug + '"') > -1) {
        var m = t.match(/urn:li:(?:fsd_company|organization|company):(\d+)/);
        if (m) return m[1];
      }
    }
    return null;
  }
  function looksLoggedOut() {
    return /\/authwall|\/login|\/signup|\/uas\//i.test(location.href)
      || !!document.querySelector('.authwall,form.login__form,.join-form')
      || /^(Sign Up|Log In|LinkedIn Login|Sign in|Join LinkedIn)/i.test(document.title || '');
  }

  var tries = 0, MAX = 12; // ~4.8s of polling for the page to hydrate
  function attempt() {
    var id = scan();
    if (id) { show(id); return; }
    if (++tries < MAX) { setTimeout(attempt, 400); return; }
    if (looksLoggedOut()) {
      alert('You appear to be on a LinkedIn sign-in page. Sign in, reload the company page, then click the bookmark again.');
    } else {
      alert('Could not find the URN for "' + slug + '" yet. Give the page a few seconds to finish loading (scroll down once), then click the bookmark again. If it keeps failing, reload the page and retry.');
    }
  }

  function show(id) {
    var u = 'urn:li:organization:' + id;
    var h = document.querySelector('h1'), n = h ? h.textContent.trim() : slug;
    var o = document.getElementById('__urnfinder__'); if (o) o.remove();
    var rowBtn = 'background:#0a66c2;color:#fff;border:0;border-radius:6px;padding:8px 12px;cursor:pointer;font-weight:600';
    var codeBox = 'flex:1;background:#f2f2f2;border-radius:6px;padding:8px 10px;font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap';
    var d = document.createElement('div');
    d.id = '__urnfinder__';
    d.style.cssText = 'position:fixed;top:24px;left:50%;transform:translateX(-50%);z-index:2147483647;background:#fff;color:#111;width:460px;max-width:92vw;font:14px/1.5 -apple-system,Segoe UI,sans-serif;border:1px solid #ccc;border-radius:12px;box-shadow:0 16px 48px rgba(0,0,0,.3);padding:18px 20px';
    // Structure via innerHTML, but the company NAME is set with textContent
    // below (never interpolated into HTML) so a name with < > & or quotes can't
    // break the dialog. The URN is digits-only, safe to inline.
    d.innerHTML = '<div style="font-weight:700;font-size:15px;margin-bottom:10px">LinkedIn URN found</div>'
      + '<div style="color:#555;margin-bottom:2px">Page name (paste into the manager):</div>'
      + '<div style="display:flex;gap:8px;align-items:center;margin-bottom:12px"><code id="__urnname__" style="' + codeBox + '"></code><button id="__namecopy__" style="' + rowBtn + '">Copy</button></div>'
      + '<div style="color:#555;margin-bottom:2px">URN to record:</div>'
      + '<div style="display:flex;gap:8px;align-items:center;margin-bottom:12px"><code style="' + codeBox + '">' + u + '</code><button id="__urncopy__" style="' + rowBtn + '">Copy</button></div>'
      + '<div style="color:#555;margin-bottom:10px">Then <b>reverse-check</b>: this button opens the numeric address — it must show the same company.</div>'
      + '<div style="display:flex;gap:8px"><a href="https://www.linkedin.com/company/' + id + '/" target="_blank" style="flex:1;text-align:center;background:#eef3f8;color:#0a66c2;text-decoration:none;border-radius:6px;padding:8px 10px;font-weight:600">Open reverse-check</a><button id="__urnclose__" style="background:#eee;border:0;border-radius:6px;padding:8px 14px;cursor:pointer">Close</button></div>';
    document.body.appendChild(d);
    document.getElementById('__urnname__')!.textContent = n;
    var nc = document.getElementById('__namecopy__')!;
    nc.onclick = function () { navigator.clipboard.writeText(n); nc.textContent = 'Copied'; };
    var cp = document.getElementById('__urncopy__')!;
    cp.onclick = function () { navigator.clipboard.writeText(u); cp.textContent = 'Copied'; };
    document.getElementById('__urnclose__')!.onclick = function () { d.remove(); };
  }

  attempt();
}
/* eslint-enable */

/** The full `javascript:…` bookmarklet URL, built from the function above. */
export function buildBookmarkletHref(): string {
  return 'javascript:(' + findLinkedInUrn.toString() + ')();';
}
